import getPublicUrl from './getPublicUrl';

export const EVENTS = {
  PRODUCT: {
    ADD_TO_CART: 'Added item to cart',
    REMOVE_FROM_CART: 'Removed item from cart',
  },
  CART: {
    BEGIN_CHECKOUT: 'Initiated payment',
  },
};

export function track(eventName, eventData) {
  if (window && window.Intercom) {
    window.Intercom('trackEvent', eventName, eventData);
  }
}

export function getGtmId(req = null) {
  const publicUrl = getPublicUrl(req);

  if (!publicUrl) return null;

  switch (publicUrl.toLowerCase()) {
    case 'https://boosthive.eu':
      return process.env.GTM_ID;

    case 'https://boosthive.net':
      return process.env.BOOSTHIVE_NET_GTM_ID;

    default:
      return null; // No matching GTM ID
  }
}



// WEBPACK FOOTER //
// ./utils/analytics.js